module.exports = __webpack_public_path__ + "static/media/Skovkortet-ipad.284426cc.jpg";